<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="font-weight-bold mt-10 title-page" tabindex="0">Revisão de Crédito</div>
      </v-col>
    </v-row>

    <br />

    <div class="mt-4" v-if="dataset.loading">
      <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
    </div>

    <div v-if="!dataset.loading && user" v-html="dataset.contentUserLogged" tabindex="0"></div>

    <br>
    <v-divider></v-divider>
    <br>

    <div v-if="user">
      <ModuleClosedAlert module="site.review.create.lawyer" />
      <v-row v-if="$modules.isOpen('site.review.create.lawyer')">
        <v-col>
          <p tabindex="0">
            <span>Caso queira adicionar uma revisão,
              <a href="/#/revisao-credito/novo"><strong>clique aqui</strong></a></span>
          </p>
        </v-col>
      </v-row>

      <v-row v-if="!dataset.loading && objectionsList.length === 0">
        <v-col>
          <v-alert type="info">
            <span>Nenhuma revisão de crédito disponível</span>
          </v-alert>
        </v-col>
      </v-row>
      <br />

      <v-alert v-if="awaitingAnswer.length" type="warning" text border="left" class="mt-2 mb-4" icon="mdi-message-reply-text-outline">
        <div class="font-weight-bold">{{ awaitingAnswer.length === 1 ? 'Há um pedido da Recuperanda aguardando resposta' : `Há ${awaitingAnswer.length} pedidos da Recuperanda aguardando resposta` }}</div>
        <div>A Recuperanda pediu a revisão do crédito de credores que você representa. Responda até <strong>{{ $moment(awaitingAnswer[0].creditor_answer.deadline_at).format('DD/MM/YYYY') }}</strong>.</div>
        <v-btn small text color="warning darken-2" class="px-0 mt-1" @click="scrollToDebtorRequests">Ver pedido<v-icon right small>mdi-arrow-down</v-icon></v-btn>
      </v-alert>

      <template v-if="objectionsList.length > 0">
        <div v-if="ownObjections.length" class="objection-section-title">
          <div class="text-h6 font-weight-bold">Pedidos de revisão dos seus representados</div>
          <div class="text-body-2 grey--text text--darken-1">Pedidos apresentados pelos credores que você representa e a análise da Administração Judicial.</div>
        </div>
        <div v-for="(objection, index) in ownObjections" :key="objection.id">

          <!-- Fase 1: "contraproposta ao QGC". Os pedidos da Recuperanda da Fase 2 ficam na seção própria, abaixo. -->
          <template v-if="objection.type === 4">
            <v-card outlined class="pa-4 mb-3" style="border-left: 5px solid #2196F3;">
              <v-row align="center">
                <v-col>
                  <div class="headline" style="font-size: 1.2rem !important; font-weight: bold; color: #1976D2;">
                    <!-- <v-icon color="primary" class="mr-2">mdi-alert-decagram</v-icon> -->
                    Credor recebeu uma contraproposta!
                    <v-chip v-if="objection.creditor_decision" small class="ml-5 font-weight-regular"
                      :color="objection.creditor_decision === 1 ? 'success' : 'error'">
                      {{ objection.creditor_decision === 1 ? 'Aceita' : 'Rejeitada' }}
                    </v-chip>
                  </div>

                  <div>
                    <strong>Nome: </strong>
                    <span class="grey--text text--darken-1 caption text-uppercase font-weight-medium">{{
                      objection.user.name }} </span>
                  </div>

                  <div>
                    <strong>CPF/CNPJ: </strong>
                    <span class="grey--text text--darken-1 caption text-uppercase font-weight-medium">{{
                      formatRegistration(objection.user.registration) }}</span>
                  </div>

                  <v-divider class="my-1" style="opacity: 0.1"></v-divider>

                  <div v-for="item in objection.items" :key="'prop-' + item.id">
                    <span class="grey--text text--darken-1 caption text-uppercase font-weight-medium mt-n5">Valor
                      Proposto</span>
                    <div class="headline primary--text font-weight-black">
                      {{ formatValue(item.amount, item.currency) }}
                      <!-- <v-chip v-if="objection.creditor_decision" small class="ml-5 font-weight-regular mb-2"
                        :color="objection.creditor_decision === 1 ? 'success' : 'error'">
                        {{ objection.creditor_decision === 1 ? 'Aceita' : 'Rejeitada' }}
                      </v-chip> -->
                    </div>
                  </div>

                  <div class="caption grey--text mt-1 italic">
                    Recebido em: {{ $moment(objection.created_at).utc().format('DD/MM/YYYY') }}
                  </div>
                </v-col>

                <!-- <v-col cols="auto">

                  <template v-if="objection.creditor_decision === null">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" color="success" class="w-100 mr-2"
                          :loading="loadingItem === objection.id && loadingType === 1"
                          :readonly="loadingItem !== null"
                          dark style="height: 30px;" @click="approveRejectOffer(objection, 1)">
                          <v-icon left>mdi-check</v-icon> Aceitar
                        </v-btn>
                      </template>
<span>Aceitar a contraproposta</span>
</v-tooltip>

<v-tooltip bottom>
  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" color="error" outlined 
                        :loading="loadingItem === objection.id && loadingType === 2"
                        :readonly="loadingItem !== null"
                        style="height: 30px;" @click="approveRejectOffer(objection, 2)">
                        <v-icon left>mdi-close</v-icon> Rejeitar
                      </v-btn>
                      </template>
  <span>Rejeitar a contraproposta</span>
</v-tooltip>

</template>

<template v-else>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" type="button" elevation="0" color="warning" dark
                        :loading="loadingItem === objection.id && loadingType === 0"
                        :readonly="loadingItem !== null"
                        style="height: 30px;" @click="approveRejectOffer(objection, 0)">
                      <v-icon left>mdi-history</v-icon> Revogar
                    </v-btn>
                      </template>
<span>Revogar / restaurar status da contraproposta</span>
</v-tooltip>

</template>
</v-col> -->
              </v-row>
            </v-card>
          </template>

          <v-card v-else outlined class="rounded-lg mb-4">
            <div class="objection-panel__header">
              <div>
                <div class="text-overline grey--text text--darken-1 objection-panel__overline">Revisão #{{ index + 1 }}</div>
                <div class="text-subtitle-1 font-weight-bold">{{ objection.user.name }}</div>
                <div class="text-caption grey--text text--darken-1">
                  {{ formatRegistration(objection.user.registration) }} · Solicitada em {{ $moment(objection.created_at).utc().format('DD/MM/YYYY') }}
                  <template v-if="objection.analyzed_at && Number(objection.status) !== 0"> · Analisada em {{ $moment(objection.analyzed_at).utc().format('DD/MM/YYYY') }}</template>
                </div>
              </div>
              <v-spacer />
              <v-btn v-if="hasLegacyProposal(objection)" small outlined class="mr-2"
                :color="getProposalColor(objection.proposal_status)" aria-label="Visualizar contraproposta recebida para este credor"
                @click="openCounterProposalDialog(objection)">
                <v-icon left small>mdi-alert-outline</v-icon>Contraproposta
              </v-btn>
              <v-chip small label :color="reviewStatus(objection).color" text-color="white">{{ reviewStatus(objection).label }}</v-chip>
            </div>
            <v-divider />

            <div class="pa-4">
            <!-- Análise da Administração Judicial (ou o aviso de que ainda não foi analisado). -->
            <div class="objection-analysis mb-3" :class="{ 'objection-analysis--pending': !hasAnalysis(objection) }">
              <div class="objection-field__label">Análise da Administração Judicial</div>
              <template v-if="hasAnalysis(objection)">
                <div class="objection-field__text objection-analysis__summary">{{ analysisSummary(objection) }}</div>
                <v-btn v-if="objection.reason" small text color="primary" class="px-0 mt-1" @click="viewReason(objection, index)">
                  <v-icon left small>mdi-text-long</v-icon>Ver análise completa
                </v-btn>
              </template>
              <div v-else class="objection-field__text grey--text text--darken-1">{{ reviewStatus(objection).hint }}</div>
            </div>
            <div v-if="hasImportantMessage(objection)" class="mt-2">
              <v-alert dense outlined type="info" class="pa-2">
                <div>
                  <strong>Aviso</strong>
                </div>

                <div class="d-flex align-start mt-1">
                  <span class="important-message-text" :class="{ 'clamped-text': !isMessageExpanded(objection) }">
                    {{ importantMessage }}
                  </span>

                  <v-btn v-if="!isMessageExpanded(objection)" text small color="primary" class="ml-1 pa-0"
                    @click="toggleMessage(objection)">
                    Mostrar mais
                  </v-btn>
                </div>

                <v-btn v-if="isMessageExpanded(objection)" text small color="primary" class="pa-0 mt-1"
                  @click="toggleMessage(objection)">
                  Mostrar menos
                </v-btn>

              </v-alert>
            </div>
            <v-row v-for="item in objection.items" :key="item.id">
              <v-col>
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header aria-label="Formulario com os dados do negócio">
                      <div>
                        <strong>Origem:</strong>
                        <span>
                          {{ truncateText(item.origin || 'N/A', 30) }}
                        </span>
                        /
                        <strong>Valor:</strong>
                        <span v-if="item.amount">
                          {{ formatValue(item.amount, item.currency) }}
                        </span>
                        <span v-else>N/A</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <p tabindex="0">
                            <span class="section-info-title">Devedora</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              {{ item.company_name }}
                            </span>
                          </p>
                          <p tabindex="0">
                            <span class="section-info-title">Origem</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              {{ item.origin }}</span>
                          </p>
                          <p v-if="item.request_number" tabindex="0">
                            <span class="section-info-title">Nº de Identificação</span>
                            <br />
                            <span class="section-info-value text-uppercase">{{
                              item.request_number
                            }}</span>
                          </p>
                          <p tabindex="0">
                            <span class="section-info-title">Moeda</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              {{ item.currency | enum(dataset.currencyTypes, 'id', 'name') }}
                            </span>
                          </p>
                          <p tabindex="0">
                            <span class="section-info-title">Valor</span>
                            <br />
                            <span class="section-info-value text-uppercase">
                              {{ formatValue(item.amount, item.currency) }}
                            </span>
                          </p>

                          <p tabindex="0">
                            <span class="section-info-title">Observações</span>
                            <br />
                            <span class="section-info-value text-uppercase">{{
                              item.observation
                            }}</span>
                          </p>

                          <p tabindex="0">
                            <span class="section-info-title">Análise da Administração Judicial</span>
                            <br />
                            <span class="section-info-value text-uppercase"
                              v-html="getTruncatedReason(objection.reason)"></span>
                            <v-btn v-if="objection.reason && stripHtml(objection.reason).length > 150" text small
                              color="primary" @click="toggleReason" class="ml-2">
                              {{ isReasonExpanded ? 'Mostrar menos' : 'Mostrar mais' }}
                            </v-btn>
                          </p>

                          <p tabindex="0">
                            <span class="section-info-title">Documento(s)</span>
                            <br />
                            <span class="section-info-value">{{ item.docs.length }} arquivo(s)</span>
                          </p>
                          <v-row>
                            <v-col v-for="(itemDoc, docIndex) in item.docs" :key="docIndex">
                              <v-card>
                                <v-img @click="openDoc(itemDoc.doc.file_url)" class="rounded-xl"
                                  lazy-src="https://picsum.photos/id/11/10/6" :height="70" :width="70"
                                  :src="itemDoc.doc.file_url"></v-img>
                                <v-card-text class="pa-0 file-text">
                                  {{ itemDoc.doc.name }}
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>

            <!-- Fase 2: contraditório da Recuperanda sobre este pedido. -->
            <DebtorContradictoryCard v-if="objectionPhase(objection) === 2" :event="objection" title="Resposta da Recuperanda ao pedido" />
            </div>
          </v-card>
        </div>

        <!-- Fase 2: pedidos de revisão apresentados pela Recuperanda para os credores representados. -->
        <section v-if="phase2DebtorRequests.length" id="pedidos-recuperanda" class="mt-2">
          <div class="objection-section-title">
            <div class="text-h6 font-weight-bold">Pedidos da Recuperanda</div>
            <div class="text-body-2 grey--text text--darken-1">
              Pedidos de revisão apresentados pela Recuperanda para os credores que você representa. A análise é feita pela Administração Judicial.
            </div>
          </div>
          <DebtorRequestCard v-for="request in phase2DebtorRequests" :key="request.id" :event="request" show-creditor />
        </section>
      </template>

      <ReviewAnalysisDialog v-model="dialogReason" :item="reasonItem" :label="`Revisão #${reasonIndex + 1}`" />
      <v-dialog v-model="dialogViewDoc" max-width="60%" @keydown.esc="cancel">
        <v-card>
          <v-img :src="selectedDoc" alt="" contain />
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title class="blue--text text--darken-2"
            style="border-bottom: 4px solid #007bff; padding-bottom: 8px;">
            Excluir revisão de crédito
          </v-card-title>
          <br>
          <v-card-text tabindex="0">
            Deseja <b>excluir</b> esta revisão de crédito?<br><br>
            <span class="font-weight-bold">OBS.:</span> Esta operação é irreversível! Caso necessário, outra revisão de
            crédito
            poderá ser criada.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" tabindex="0" text @click="dialog = false"
              aria-label="Botão para cancelar operação e não remover a revisão de crédito">Cancelar</v-btn>
            <v-btn color="red" tabindex="0" text @click="confirmDelete()"
              aria-label="Botão para confirmar a remoção da revisão de crédito">Excluir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="counterProposalDialog" max-width="600">
        <v-card>
          <v-card-title class="black--text text--darken-2"
            style="border-bottom: 3px solid gray; padding-bottom: 8px; display: flex; justify-content: center;">
            Contraproposta Recebida</v-card-title>
          <v-card-text v-if="proposalObjection">
            <br>
            <span>O credor <strong>{{ proposalObjection.user.name }}</strong>
              recebeu uma contraproposta no valor de <strong> {{ formatValue(proposalObjection.proposal_amount)
                }}</strong>.
            </span>
            <br>
            <br>
            <span v-if="proposalObjection.proposal_status !== 0">
              <template v-if="isProposalExpired">
                O prazo para aceitar ou rejeitar a contraproposta encerrou em
                <strong>{{ $moment(proposalObjection.proposal_deadline_at).format('DD/MM/YYYY') }}</strong>.
              </template>
              <template v-else>
                O credor tem até
                <strong>{{ $moment(proposalObjection.proposal_deadline_at).format('DD/MM/YYYY') }}</strong>
                para aceitar ou rejeitar a contraproposta.
              </template>
            </span>
            <br>
            <br>
            <v-alert outlined
              :color="proposalObjection.proposal_status === 1 ? 'green' : proposalObjection.proposal_status === 2 ? 'red' : '#FF6F00'"
              :style="{
                backgroundColor: 'transparent',
                borderColor: (proposalObjection.proposal_status === 1 ? 'green' : proposalObjection.proposal_status === 2 ? 'red' : '#FF6F00') + ' !important',
                borderWidth: '2px' + '!important',
              }" icon="mdi-alert-outline">
              <template v-if="proposalObjection.proposal_status === 1">
                O credor <strong>aceitou</strong> a contraproposta no dia
                <strong>{{ $moment(proposalObjection.proposal_creditor_at).format("DD/MM/YYYY") }}</strong>.
              </template>

              <template v-else-if="proposalObjection.proposal_status === 2">
                O credor <strong>rejeitou</strong> a contraproposta no dia
                <strong>{{ $moment(proposalObjection.proposal_creditor_at).format("DD/MM/YYYY") }}</strong>.
              </template>

              <template
                v-else-if="isProposalExpired && proposalObjection.proposal_status !== 1 && proposalObjection.proposal_status !== 2">
                O prazo para aceitar ou rejeitar a contraproposta expirou no dia
                <strong>{{ $moment(proposalObjection.proposal_deadline_at).format("DD/MM/YYYY") }}</strong>.
              </template>

              <template v-else>
                O prazo para aceitar ou rejeitar a contraproposta se encerra no dia
                <strong>{{ $moment(proposalObjection.proposal_deadline_at).format("DD/MM/YYYY") }}</strong>.
              </template>
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip bottom v-if="proposalObjection && proposalObjection.proposal_status === 0 && !isProposalExpired">
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="dataset.loading" small color="success" v-bind="attrs" v-on="on"
                  @click="responseProposal(1)">
                  Aceitar
                </v-btn>
              </template>
              <span>Aceitar a contraproposta</span>
            </v-tooltip>

            <v-tooltip bottom v-if="proposalObjection && proposalObjection.proposal_status === 0 && !isProposalExpired">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-2" :disabled="dataset.loading" small color="error" v-bind="attrs" v-on="on"
                  @click="responseProposal(2)">
                  Rejeitar
                </v-btn>
              </template>
              <span>Rejeitar a contraproposta</span>
            </v-tooltip>

            <v-tooltip bottom v-if="proposalObjection && proposalObjection.proposal_status !== 0 && !isProposalExpired">
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="dataset.loading" small color="mediumGray" dark v-bind="attrs" v-on="on"
                  @click="responseProposal(0)">
                  Revogar
                </v-btn>
              </template>
              <span>Revogar decisão anterior</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-10" small color="primary" outlined dark v-bind="attrs" v-on="on"
                  @click="counterProposalDialog = false">
                  Voltar
                </v-btn>
              </template>
              <span>Fechar e voltar</span>
            </v-tooltip>
            <br>
            <br>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal para motivo Rejeitar contraproposta -->
      <v-dialog v-model="showRejectConfirmation" max-width="600px">
        <v-card>
          <v-card-title class="card-title"
            style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
            MOTIVO
          </v-card-title>
          <br>
          <v-card-text>
            <p>
              Digite o motivo pelo qual está rejeitando a contraproposta.
            </p>
            <br>
            <v-form ref="rejectionForm" @submit.prevent="confirmRejectStatus">
              <v-row>
                <v-col cols="12" md="12">
                  <v-textarea label="Motivo" v-model="rejectionReasonText" outlined dense clearable auto-grow rows="1"
                    counter maxlength="255"></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-spacer></v-spacer>
                <v-btn text color="grey" @click="cancelReject">Cancelar</v-btn>
                <v-btn color="primary" type="submit">Rejeitar</v-btn>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <div class='mt-10' v-if='!user'>
      <h4>Por favor, realize o seu login para ter acesso a revisão de crédito.</h4>
    </div>
  </v-container>
</template>

<script>
import 'moment/locale/pt-br'
import { eventHub } from '@/main'
import currencyTypes from '@/common/data/currency-types.data'
import creditorDocTypes from '@/common/data/creditor-email-doc-types.data'
import businessDocTypes from '@/common/data/business-doc-types.data'
import axios from 'axios'

import moment from 'moment-timezone'
import DebtorRequestCard from '@/components/objection/DebtorRequestCard.vue'
import DebtorContradictoryCard from '@/components/objection/DebtorContradictoryCard.vue'
import ReviewAnalysisDialog from '@/components/objection/ReviewAnalysisDialog.vue'
import { objectionPhase, isPhase2DebtorRequest, hasLegacyProposal, reviewStatus, hasAnalysis, analysisSummary } from '@/common/util/objection-phase'

export default {
  components: { DebtorRequestCard, DebtorContradictoryCard, ReviewAnalysisDialog },
  props: {

  },
  data: () => ({
    user: null,
    associatedUsers: [],
    objectionsList: [],
    reasonItem: null,
    reasonIndex: 0,
    loading: false,
    loadingItem: null,
    loadingType: null,
    showRejectConfirmation: false,
    rejectionReasonText: '',
    rejectResolver: null,
    dialog: false,
    dialogReason: false,
    isReasonExpanded: false,
    selectedItem: null,
    selectedItemReason: null,
    isProposalExpired: false,
    // creditorDocTypes: creditorDocTypes,
    // businessDocTypes: businessDocTypes,
    requestedDocDeadline: null,
    requestedDocOutOfDate: false,
    dataset: {
      contentUserAnonymous: '',
      contentUserLogged: '',
      currencyTypes: currencyTypes,
      isAssociationCreditor: false,
      userRequestedValue: 0,
      loading: false,
      clients: [],
      data: {
        items: [],
        client: null,
        release_status: null,
      }
    },

    selectedDoc: null,
    dialogViewDoc: false,


    loadingStatus: false,
    lawyerId: null,

    //variáveis para o diálogo de contrapoposta
    counterProposalDialog: false,
    proposalObjection: null,

  }),

  created() {
    this.$ga.event({
      eventCategory: 'page',
      eventAction: 'action',
      eventLabel: 'click',
      eventValue: 'user-area'
    })

    this.loadData()
    // this.loadUserInfo();

    this.user = this.$root.user
  },

  computed: {
    // Pedidos da Recuperanda com prazo aberto e ainda sem resposta (destaque no topo da página).
    awaitingAnswer() {
      return this.phase2DebtorRequests.filter(item => item.creditor_answer && item.creditor_answer.can_answer && !item.creditor_answer.answered);
    },
    // Pedidos dos credores representados (e as contrapropostas da Fase 1); os da Recuperanda na Fase 2 têm seção própria.
    ownObjections() {
      return this.objectionsList.filter(item => !isPhase2DebtorRequest(item));
    },
    phase2DebtorRequests() {
      return this.objectionsList.filter(item => isPhase2DebtorRequest(item));
    },
    // Data do fim do prazo configurada em Módulos e prazos > Parâmetros.
    importantMessage() {
      return `Prezado credor, o prazo para envio das Revisões de Crédito encerrou-se em ${this.$modules.parameterDate('review.timely_cutoff')}, conforme cronograma apresentado pela Administração Judicial, nos termos do EDITAL DE CONVOCAÇÃO PARA A FASE PRÉVIA E PRELIMINAR DE REVISÃO DE CRÉDITOS e de CONHECIMENTO DA RELAÇÃO DE CREDORES APRESENTADA PELA ADMINISTRAÇÃO JUDICIAL E PREVISTA NO ART. 7º, §2º, DA LEI 11.101/2005, elaborado conforme decisão judicial.`;
    },


  },

  methods: {
    scrollToDebtorRequests() {
      const section = document.getElementById('pedidos-recuperanda');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    objectionPhase,
    isPhase2DebtorRequest,
    hasLegacyProposal,
    reviewStatus,
    hasAnalysis,
    analysisSummary,

    viewReason(item, index = 0) {
      this.reasonItem = item;
      this.reasonIndex = index;
      this.dialogReason = true;
    },
    async loadData() {
      this.dataset.loading = true
      this.loadingStatus = true

      try {
        await this.loadText()

        if (this.$root.user) {
          // await this.verifyAssociation()
          await this.load()
          // await this.fetchReleaseStatus()

        }
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataset.loading = false
      }
    },

    toggleMessage(objection) {
      if (typeof objection.showMessage === 'undefined') {
        this.$set(objection, 'showMessage', true)
      } else {
        objection.showMessage = !objection.showMessage
      }
    },

    isMessageExpanded(objection) {
      return objection.showMessage === true
    },

    // Revisões criadas depois da data configurada (Módulos e prazos > Parâmetros) mostram o aviso de prazo encerrado.
    hasImportantMessage(objection) {
      return this.$moment(objection.created_at).isAfter(this.$modules.parameter('review.lawyer_notice_after'), 'day')
    },

    formatAmount(value) {
      if (!value) return 'R$ 0,00';
      return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },

    isLoading(doc) {
      return this.loadingDocs.includes(doc.document_id);
    },

    getProposalColor(status) {
      if (status === 0) return "warning";
      if (status === 1) return "green";
      if (status === 2) return "red";
      return "grey";
    },

    openCounterProposalDialog(objection) {

      this.proposalObjection = objection;

      if (objection.proposal_deadline_at) {
        const deadline = this.$moment(objection.proposal_deadline_at);
        const now = this.$moment();

        this.isProposalExpired = now.isAfter(deadline);
      } else {
        this.isProposalExpired = false;
      }
      this.counterProposalDialog = true;
    },

    async responseProposal(status) {
      if (this.$moduleBlocked('site.counterproposal.answer')) return;
      if (this.proposalObjection.proposal_status === status) {
        this.$dialog.notify.warning(
          'O status atual já corresponde ao status selecionado.',
          { position: 'top-right', timeout: 5000 }
        );
        return;
      }

      this.dataset.loading = true;
      try {
        const response = await axios.post('/api/lawyer-user-objection-events/response-event-proposal',
          {
            proposal_status: status,
            user_objection_event_id: this.proposalObjection.id,
          }
        );

        if (response && response.status === 200) {
          let msg = '';
          switch (status) {
            case 1:
              msg = 'Contraproposta aceita com sucesso!';
              break;
            case 2:
              msg = 'Contraproposta rejeitada com sucesso!';
              break;
            case 0:
              msg = 'Decisão anterior revogada com sucesso!';
              break;
            default:
              msg = 'Ação realizada com sucesso!';
          }
          this.$dialog.notify.success(msg, { position: 'top-right', timeout: 5000 });
        } else {
          throw new Error('Erro ao responder à contraproposta!');
        }
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
      } finally {
        this.dataset.loading = false;
        this.counterProposalDialog = false;
        this.loadData();
      }
    },

    async approveRejectOffer(item, value) {
      if (this.$moduleBlocked('site.counterproposal.answer')) return;

      const messages = {
        0: { title: 'Revogar contraproposta', text: 'Deseja revogar a contraproposta?', success: 'Contraproposta revogada com sucesso!' },
        1: { title: 'Aceitar contraproposta', text: 'Deseja aceitar a contraproposta?', success: 'Contraproposta aceita com sucesso!' },
        2: { title: 'Rejeitar contraproposta', text: 'Deseja rejeitar a contraproposta?', success: 'Contraproposta rejeitada com sucesso!' }
      };

      const msg = messages[value];
      if (!msg) {
        this.$dialog.notify.error('Status inválido.', { position: 'top-right', timeout: 5000 });
        return;
      }

      const proceedAction = await this.$dialog.confirm({
        text: msg.text,
        title: msg.title,
        actions: {
          false: 'NÃO',
          true: 'SIM'
        }
      });

      if (!proceedAction) return;

      let creditor_reason = null;

      if (value === 2) {

        this.rejectionReasonText = '';
        this.showRejectConfirmation = true;

        creditor_reason = await new Promise((resolve) => {
          this.rejectResolver = resolve;
        });

        this.showRejectConfirmation = false;

        if (!creditor_reason) return;

      }

      if (value === 2 && !creditor_reason) {

        this.$dialog.notify.warning('É necessário informar um motivo para rejeitar.', { position: 'top-right' });

        return;
      }

      this.loadingItem = item.id;
      this.loadingType = value;

      try {
        const response = await axios.post(
          '/api/lawyer-user-objection-events/response-event-debtor-proposal',
          {
            creditor_decision: value,
            creditor_decision_reason: creditor_reason,
            user_objection_event_id: item.id,
            user_id: item.user.id
          }
        );

        if (response.status === 200) {
          this.$dialog.notify.success(msg.success, { position: 'top-right', timeout: 5000 });
          this.loadData();
        } else {
          throw new Error('Erro ao responder à contraproposta.');
        }
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
      } finally {
        this.loadingItem = null;
        this.loadingType = null;
      }
    },

    confirmRejectStatus() {
      if (!this.rejectionReasonText.trim()) {
        return this.$dialog.notify.warning('Informe o motivo');
      }
      // Resolve a promessa enviando o texto digitado
      this.rejectResolver(this.rejectionReasonText);
    },

    cancelReject() {
      this.showRejectConfirmation = false;
      // Resolve com null para o método principal saber que foi cancelado
      this.rejectResolver(null);
    },

    getCurrencyCode(currencyType) {
      switch (currencyType) {
        case 1:
          return 'BRL';
        case 2:
          return 'USD';
        case 3:
          return 'EUR';
        default:
          return 'BRL';
      }
    },

    formatValue(value, currency) {
      if (value === null || value === undefined) {
        return 'N/A'
      }

      let options = {
        style: 'currency',
        currency: 'BRL'
      }

      switch (currency) {
        case 1:
          options.currency = 'BRL'
          break
        case 2:
          options.currency = 'USD'
          break
        case 3:
          options.currency = 'EUR'
          break
        default:
          options.currency = 'BRL'
      }

      return new Intl.NumberFormat('pt-BR', options).format(value)
    },

    truncateText(text, maxLength) {
      return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
    },

    openDoc(doc) {
      window.open(doc, '_blank')
    },

    formatCpf(value) {
      if (!value) return '';
      return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
    },

    formatCnpj(value) {
      if (!value) return '';
      return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    },

    formatRegistration(value) {
      if (!value) return '';
      return value.length <= 11 ? this.formatCpf(value) : this.formatCnpj(value);
    },

    async fetchReleaseStatus() {
      this.loadingStatus = true;

      try {
        const result = await axios.get(`/api/clients/1`);

        const data = result.data.content;

        this.dataset.data = {
          ...data,
          release_status: data.release_status,
        };

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.loadingStatus = false;
      }
    },

    async verifyAssociation() {
      const result = await axios.get('/api/user-creditors/association')

      const data = result.data.content

      // if (!data) return;

      if (!data || data.length === 0) return

      this.dataset.isAssociationCreditor = true
      this.dataset.userRequestedValue = data[0].amount
    },

    async loadText() {
      const result = await axios.get(`/api/dynamic-infos/keys`, {
        params: { keys: 'objection-request-description' }
      })

      if (!result.data.content) return

      this.dataset.contentUserLogged = result.data.content[0].value

    },

    async loadUserInfo() {
      try {
        const result = await axios.get('/api/users/info')

        this.user = result.data.content

        this.isTimely =
          this.user.timely_date && this.user.timely_date !== '0000-00-00 00:00:00';

        const eventResponse = await axios.get(`/api/user-objection-events/request`);
        const events = eventResponse.data.content;

        this.showLateWarning = events.some(event => {
          const eventDate = new Date(event.created_at);
          return eventDate >= new Date('2024-12-04T00:00:00');
        });

      } catch (error) {
        console.error('Erro ao carregar informações do usuário:', error);
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000,
        });
      }
    },

    async load() {
      this.dataset.loading = true;
      try {
        const usersResult = await axios.get('/api/lawyers/associated-users');
        this.associatedUsers = usersResult.data.content.data || [];

        const objectionsResult = await axios.get('/api/user-objection-events/lawyer-request');
        this.objectionsList = objectionsResult.data.content || [];

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        });
      } finally {
        this.dataset.loading = false;
      }
    },


    getColorByStatus(status) {
      switch (status) {
        case 0:
          return 'warning'
        case 1:
          return 'accent'
        case 2:
          return 'important'
        case 3:
          return 'primary'
        case 4:
          return '#FF6F00'
        default:
          break
      }
    },

    getTextByStatus(status) {
      switch (status) {
        case 0:
          return 'Aguardando análise'
        case 1:
          return 'Aprovado'
        case 2:
          return 'Rejeitado'
        case 3:
          return 'Aprovado parcial'
        case 4:
          return 'Atualizar doc.'

        default:
          break
      }
    },

    // editItem(objectionEventId) {
    //   this.$router.push(`revisao-credito/${objectionEventId}`);
    //   window.scrollTo(0, 0);
    // },

    // openDeleteDialog(item) {
    //   this.selectedItem = item;
    //   this.dialog = true;
    // },

    async confirmDelete() {
      this.dialog = false;
      if (this.selectedItem) {
        await this.deleteItem(this.selectedItem);
      }
    },

    async deleteItem(item) {
      if (this.$moduleBlocked('site.review.edit')) return;
      this.dataset.loading = true;
      try {
        const response = await axios.delete(`/api/user-objection-events/lawyer/request/delete/${item.id}`);

        this.$dialog.notify.success("Revisão de crédito excluída com sucesso!", { position: 'top-right', timeout: 5000 });
        this.load();
      } catch (error) {

        let errorMessage = "Erro ao excluir a revisão de crédito!";

        if (
          error.response &&
          error.response.data &&
          error.response.data.content &&
          error.response.data.content.error &&
          error.response.data.content.error.message
        ) {
          errorMessage = error.response.data.content.error.message;
        }

        this.$dialog.notify.error(errorMessage, {
          position: "top-right",
          timeout: 5000
        });

      } finally {
        this.dataset.loading = false;
        this.selectedItem = null;
      }
    },


    stripHtml(html) {
      if (!html) return '';
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    },

    getTruncatedReason(reason) {
      const rawText = this.stripHtml(reason);
      if (!this.isReasonExpanded && rawText.length > 150) {
        return rawText.substring(0, 150) + '...';
      }
      return rawText;
    },

    toggleReason() {
      this.isReasonExpanded = !this.isReasonExpanded;
    }


  }
}
</script>

<style lang="scss">
.title-page {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}

.section-info-title {
  color: var(--v-primary-base);
  font-family: 'Raleway';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

.section-info-value {
  font-family: 'Raleway';
  font-size: 14px;
  font-style: normal;
}

.custom-panel-header {
  min-height: 20px !important;
  line-height: 20px !important;
  padding-top: 5 !important;
  padding-bottom: 0 !important;
}

.card-title {
  border-bottom: 4px solid #2373c9 !important;
  padding-bottom: 8px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  // font-family: 'Raleway' !important;
  font-weight: 650 !important;
  font-size: 20px !important;
  font-style: bold !important;
  text-align: center !important;
}

.button-with-border {
  background-color: #ffffff;
  border: 2px solid #FF6F00;
  padding: 10px 20px;
  border-radius: 5px;
}

.button-with-border:hover {
  background-color: #f7994d;
  color: rgb(247, 243, 243) !important;
}

.compact-item {
  margin: 0;
  padding: 0;
}

.compact-item p {
  margin: 4px 0;
  font-size: 14px;
}

.doc-title {
  white-space: normal;
  word-wrap: break-word;
  max-width: calc(100% - 120px);
  margin-right: 16px;
}

.compact-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.important-message-text {
  font-size: 0.85rem;
  line-height: 1.5;
  display: inline;
}

.clamped-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>